export const RESOURCE_REQUEST_POLL_MS = 2000;
